/* eslint-disable angular/component-name */
/* globals d3,nv */
import Zcd3 from 'libs/zcd3';

angular.module('zc.zenclerkS')
  .component('widgetConversionChart', {
    templateUrl: '/templates/zenclerk_s/directives/dashboard/conversion_chart_widget.html',
    bindings: {
      project: '<'
    },
    controller: function($translate, $element, AccessStats) {
      let vm = this;
      const region = vm.project.region;

      // TODO: get the color from classes
      // colorPrimary = angular.element(".chart-primary").css('color')
      // colorSecondary = angular.element(".chart-secondary").css('color')
      const colorPrimary = '#775FD3';
      const colorSecondary = '#1DD5A3';

      vm.conversionData = [];
      vm.sessionData = [];

      this.$onInit = () => {
        if(vm.project.is_demo) {
          let dates = getMonthlyDateKeys(moment.tz(region).format('YYYY-MM'));


          vm.conversionData = [];
          vm.sessionData = [];

          _.each(dates, (date, i) => {
            if(moment.tz(date, region).isAfter(moment.tz(region))) return;

            vm.conversionData.push({date: moment.tz(date, 'YYYY-MM-DD', region).valueOf(), conversionCount: Math.round(Math.random() * 3 + 3)});
            vm.sessionData.push({date: moment.tz(date, 'YYYY-MM-DD', region).valueOf(), sessionCount: Math.round(Math.random() * 10 * i + 300)});
          });

          createChart();
        } else {
        // on 1st day we don't have data yet so show last month
          const startAt = moment.tz(region).subtract(1, 'days').startOf('month').toDate();
          const endAt = moment.tz(region).subtract(1, 'days').endOf('month').toDate();

          AccessStats.find({
            dimension: 'daily',
            apikey: vm.project.apikey
          }, {
            match: {
              apikey: vm.project.apikey,
              device: null,
              campaign_segment_id: null,
              total_conversion_count: null,
              is_control: null,
              is_after_installed_at: null,
              start_at: {
                $gte: startAt,
                $lte: endAt
              },
            },
            sort: { start_at: 1 },
          }).then(res => {
            vm.sessionData = _.map(res, d => {
              return {
                date: moment.tz(d.start_at, region).toDate(),
                conversionCount: d.conversion_count,
                sessionCount: d.session_count
              };
            });

            createChart();
          });
        }
      };

      function createChart() {
        const WIDTH = $element.find('.widget-conversion-chart').width();
        const el = $element.find('.chart-conversion')[0];

        const deliveryGraph = new Zcd3(el, vm.sessionData, {
          width: WIDTH - 30,
          height: 260,
          padding: {
            left: 35,
            right: 50
          },
          isBarChart: true, // TODO: get rid of this, just for padding
          tooltipFn: (d, opts) => `
          ${opts.timeFormats.day(d.date)}<br>
          <div class="legend-rect" style="background-color: ${colorPrimary}"></div> ${$translate.instant('directives.dashboard.common.numberOfCV', { value: d.conversionCount })}<br>
          <div class="legend-rect" style="background-color: ${colorSecondary}"></div> ${$translate.instant('directives.dashboard.common.numberOfVisitors', { value: d.sessionCount })}`
        });

        deliveryGraph.addSeries({
          name: 'delivery-session-count',
          type: 'bar',
          x: 'date',
          y: 'conversionCount',
          color: colorPrimary,
        });

        deliveryGraph.addSeries({
          name: 'delivery-percentage',
          type: 'line',
          x: 'date',
          y: 'sessionCount',
          yAxis: 'right',
          // yAxisTickFormat: asPercent,
          color: colorSecondary,
        });

        deliveryGraph.createVerticalPositionIndicator();
      }

      function getMonthlyDateKeys(month) {
        let lastDayOfMonth = moment.tz(month, 'YYYY-MM', region).endOf('month').date();
        return _.map(_.range(1, lastDayOfMonth), d => moment.tz(month, 'YYYY-MM', region).date(d).format('YYYY-MM-DD'));
      }
    }
  });



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/dashboard/conversion_chart_widget.js